<template>
  <div>
    <transition name="modal">
      <div class="modal-mask w3-modal" style='height: 100vh;'>
        <div class="w3-container modal-wrapper" @click="$emit('close')">
          <div class="modal-container w3-modal-content " @click.stop>
            <span 
              @click="$emit('close')"
              class="w3-button w3-display-topright"
              style="margin-top:0; height: 40px; width: 40px;">
              &times;
            </span>
            
            <h4 
              class="titulo-modal" 
              v-if="(xml == '5') || 
              (xml == '10') || 
              (xml == '20+')">
              <i class="far fa-calendar-alt"></i>
              Entradas nos ultimos {{xml}} dias
            </h4>
            
            <h4 class="titulo-modal" v-else>
              <i class="far fa-calendar-alt"></i> 
              Entradas com críticas {{xml}}
            </h4>

            <div class="modal-header">
              <slot name="header" style="margin-left: 10px">
                <div style="margin-left: 10px">
                  <div class="alert-assinatura modal-assinatura" >
              
                    <div
                      class="card-item w3-container"
                      v-for="(item, item_index) in listaXml"
                      :key="item_index"
                      @click="toogleItems(item, !item.mostrar)" 
                      :class="{'card-informacoes-selecionado': item.mostrar }">
                      
                      <div class="w3-col s12">
                        <label>Análise: </label>
                        <strong>{{item.analise_id}}</strong>
                      </div>
                      
                      <div class="w3-col s12">
                        <label>Data hora análise: </label>
                        <strong>{{item.data_hora_analise}}</strong>
                      </div>
                      
                      <div class="w3-col s12">
                        <label>Fornecedor: </label>
                        <strong>{{item.fornecedor_analise}}</strong>
                      </div>
                      
                      <div class="w3-col s12">
                        <label>Status: </label>
                        <strong>{{item.status_analise_analitico}}</strong>
                      </div>
                      
                      <transition name="fade" mode="out-in">
                        <div v-if="item.mostrar">
                          <div class="w3-col s12">
                            <label>Status entrada análitico: </label>
                            <strong>{{item.status_entrada_analitico}}</strong>
                          </div>
                          
                          <div class="w3-col s12">
                            <label>Manifestação destinatário: </label>
                            <strong>{{item.manifestacao_destinatario_id}}</strong>
                          </div>
                          
                          <div class="w3-col s12">
                            <label>XML Entrada: </label>
                            <strong>{{item.xml_entrada_id}}</strong>
                          </div>
                          
                          <div class="w3-col s12">
                            <label>Tipo importação: </label>
                            <strong>{{item.tipo_importacao_analise}}</strong>
                          </div>
                          
                          <div class="w3-col s12">
                            <label>Chave NFE: </label>
                            <strong  style="overflow:hidden; word-break: break-all;">{{item.chave_nfe}}</strong>
                          </div>
                          
                          <div class="w3-col s12">
                            <label>Nota: </label>
                            <strong>{{item.numero_nota}}</strong>
                          </div>
                          
                          <div class="w3-col s12">
                            <label>Modelo nota: </label>
                            <strong>{{item.modelo_nota}}</strong>
                          </div>
                          
                          <div class="w3-col s12">
                            <label>Séria nota: </label>
                            <strong>{{item.serie_nota}}</strong>
                          </div>
                          
                          <div class="w3-col s12">
                            <label>Empresa: </label>
                            <label>{{item.empresa_analise}}</label>
                          </div>
                          
                          <div class="w3-col s12">
                            <label>Empresa id: </label>
                            <strong>{{item.empresa_id}}</strong>
                          </div>
                          
                          <div class="w3-col s12">
                            <label>Hora emissão: </label>
                            <strong>{{item.data_hora_emissao}}</strong>
                          </div>
                          
                          <div class="w3-col s12">
                            <label>CFOP: </label>
                            <strong>{{item.cfop}}</strong>
                          </div>
                          
                          <div class="w3-col s12">
                            <label>Criticas cadastro: </label>
                            <strong>{{item.criticas_cadastro}}</strong>
                          </div>
                          
                          <div class="w3-col s12">
                            <label>Critiscas fiscal: </label>
                            <strong>{{item.criticas_fiscal}}</strong>
                          </div>
                          
                          <div class="w3-col s12">
                            <label>Criticas negociação: </label>
                            <strong>{{item.criticas_negociacao}}</strong>
                          </div>
                          
                          <div class="w3-col s12">
                            <label>CPF/CNPJ: </label>
                            <strong>{{item.cpf_cnpj}}</strong>
                          </div>
                          
                          <div class="w3-col s12">
                            <label>Inscrição estadual: </label>
                            <strong>{{item.inscricao_estadual_xml}}</strong>
                          </div>
                          
                          <div class="w3-col s12">
                            <label>Desconto: </label>
                            <strong>{{item.valor_desconto }}</strong>
                          </div>
                          
                          <div class="w3-col s12">
                            <label>Frete: </label>
                            <strong>{{item.valor_frete}}</strong>
                          </div>
                          
                          <div class="w3-col s12">
                            <label>Outras despesas: </label>
                            <strong>{{item.valor_outras_despesas}}</strong>
                          </div>
                          
                          <div class="w3-col s12">
                            <label>IPI: </label>
                            <strong>{{item.valor_ipi}}</strong>
                          </div>
                          
                          <div class="w3-col s12">
                            <label>ICMS: </label>
                            <strong>{{item.base_icms}}</strong>
                          </div>
                          
                          <div class="w3-col s12">
                            <label>Valor ICMS: </label>
                            <strong>{{item.valor_icms}}</strong>
                          </div>
                          
                          <div class="w3-col s12">
                            <label>Base st: </label>
                            <strong>{{item.base_st}}</strong>
                          </div>
                          
                          <div class="w3-col s12">
                            <label>Valor st: </label>
                            <strong>{{item.valor_st}}</strong>
                          </div>
                          
                          <div class="w3-col s12">
                            <label>Valor Pis: </label>
                            <strong>{{item.valor_pis}}</strong>
                          </div>
                          
                          <div class="w3-col s12">
                            <label>Valor Cofins: </label>
                            <strong>{{item.valor_cofins}}</strong>
                          </div>
                          
                          <div class="w3-col s12">
                            <label>Valor produtos: </label>
                            <strong>{{item.valor_produtos}}</strong>
                          </div>
                          
                          <div class="w3-col s12">
                            <label>Valor nota: </label>
                            <strong>{{item.valor_nota}}</strong>
                          </div>
                          
                          <div class="w3-col s12">
                            <label>Madeira: </label>
                            <strong>{{item.madeira}}</strong>
                          </div>
                          
                          <div class="w3-col s12">
                            <label>Numero pedido: </label>
                            <strong>{{item.numero_pedido}}</strong>
                          </div>
                          
                          <div class="mapa-financeiro-card" style="padding:0">
                            <modal-items-xml :items="item.itens" :criticas="item.criticas"></modal-items-xml>
                          </div>
                        </div>
                      </transition>
                    </div>
                  </div>
                </div>
              </slot>
            </div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>
<script>
  import ModalItemsXml from '@/components/Dashboard/ModalItensXml'

  export default {
    name: 'ModalXmlEntradasDias',
    props: ['xml', 'listaXml'],
    components: {
      ModalItemsXml
    },
    data() {
      return {
        api: process.env.API,
      }
    },
    computed: {

    },
    mounted() {

    },
    methods: {
      toogleItems(item, condicional) {
        this.$set(item, 'mostrar', condicional)
      },
      TratarWebErroJSONLocal: function(retorno){
        if (retorno.msg != undefined){
          var erro = retorno;
          toastr.error(
            'Código do erro: ' +
            erro.codigo_erro + 
            ' \n Classe: ' +
            erro.classe_erro + 
            ' \n Erro: ' + 
            erro.msg, 
            'Erro ao realizar a requisição!'
          );
          return;
        }      

        else {
          var erro = retorno;
          toastr.error(
            'Código do erro: ' +
            erro.codigo_erro + 
            ' \n Classe: ' +
            erro.classe_erro + 
            ' \n Erro: ' + 
            erro.msg,
            'Erro ao realizar a requisição!'
          );
          return;
        }
      }
    }
  }
</script>
<style scoped>
.card-item {
  background: white;
  border-radius: 10px;
  margin-bottom: 10px;
  padding: 5px !important;
  border: 2px solid #ccc;
  box-shadow: #6b6b6b 2px 2px 5px 2px;
}
.modal-header {
  overflow: auto;
  height: 90%;
  /* max-height: 500px; */
  margin: auto;

}

.modal-header {
  margin: 3%;
  margin-left: 1%;
}

.modal-container {
  padding-left: 0;
  padding-right: 0;
}
.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, .5);
  display: table;
  transition: opacity .3s ease;
}

.modal-wrapper {
  display: table-cell;
  padding-top: 20px
}

.modal-container {
  animation: animatezoom 0.6s;
  margin: auto;
  height: 100%;
  max-height: 95%;
  overflow: auto;  padding: 20px 30px;
  background-color: #fff;
  border-radius: 1  2px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, .33);
  transition: all .3s ease;
  font-family: Helvetica, Arial, sans-serif;
}

.modal-header h3 {
  margin-top: 0;
  color: #42b983;
}

.modal-body {
  margin: 20px 0;
}

.modal-default-button {
  float: right;
}

.modal-enter {
  opacity: 0;
}

.modal-leave-active {
  opacity: 0;
}

.modal-enter .modal-container,
.modal-leave-active .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}
button {
    background: #9c1d1c;
    color: white;
    padding: 5px
}
.modal-assinatura {
  margin: auto !important;
  margin-bottom: 10px !important
}
.aviso-tamanho-tela {
  display: none;
}
@media only screen and (max-width: 450px) {
    /* .modal-assinatura {
      display: none;
    } */
}
@media (max-width: 450px) {
    .aviso-tamanho-tela {
      display: inherit;
      text-align: center;
      color: red;
    }
}
  @media(max-width: 645px) {
    .modal-container {
      padding-left: 3px !important;
      padding-right: 3px !important;
    }
  }
@media (min-width: 1203px){
  .w3-modal-content {
      width: 1200px;
  }
}

.w3-button {
  padding: 10px;
  margin-top: 10px
}
td {
  text-align: center !important
}

thead {
  background: #d4d4d4
}

.fade-enter-active, .fade-leave-active {
transition: opacity .4s;
}
.fade-enter, .fade-leave-to {
  opacity: 0;
}
.tr-items-ativo:hover {
  background:#9c1d1c2e !important;
    color: black


}
.tr-items-ativo {
  background: #a53231 !important;
  color: white

}
.tr-items {
  cursor: pointer;
  transition: 0.2s
}
.tr-items:hover {
 background: #9c1d1cb8;
    color:#fff;
}
.titulo-modal {
  text-align: center;
  color: #9c1d1c;
  padding: 5px

}
.card-informacoes {
  margin-bottom: 10px;
  border-left-style: solid;
  border-left-color: #636363;
  border-bottom-style: solid;
  border-bottom-width: 1px;
  float: left;
  padding: 7px;
  border-bottom-color: #636363 !important;
  cursor: pointer;
  transition: 0.2s;
  width: 100%
}
.card-informacoes-selecionado {
  background-color: rgb(235, 235, 235) !important;
  
}
.card-informacoes:hover {
  background: #eeeeee
}
th, td {
  white-space: nowrap;
  text-align: center
}
.card-pedido-bloqueado {
  margin-top: 10px !important
}

</style>



// WEBPACK FOOTER //
// src/components/Dashboard/ModalXmlEntradasDias.vue